import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://easystore-ws2.modullo.net/connect',
  // baseURL: 'https://easystore-dev.modullo.net/connect',
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
})

export default instance



// WEBPACK FOOTER //
// ./src/store/authentication.js